import { render, staticRenderFns } from "./AddMachineToDashboard.vue?vue&type=template&id=a946cc54"
import script from "./AddMachineToDashboard.vue?vue&type=script&lang=js"
export * from "./AddMachineToDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports